import Vue from 'vue'
import Vuex from 'vuex'
import request from '@/plugins/http'

Vue.use(Vuex)

// 扫描当前目录下的所有js文件包括子目录的js
/* 正则: 包含.js文件 但不包含./dist目录 dist目录不扫描 */
const files = require.context('@/store/modules', true, /^((?!\.\/dist).)*\.js(?!\.\/dist).*$/)
const modules = files.keys().reduce((modulesItem, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = files(modulePath)
  modulesItem[moduleName] = value.default
  return modulesItem
}, {})

export default new Vuex.Store({
  modules: modules,
  state: {
    routerList: (localStorage.getItem('routerList') &&
      JSON.parse(localStorage.getItem('routerList'))) || [
        {
          id: 1,
          name: '服务商查询',
          link: '/home/serverCheck'
        }
      ],
    // routerList: '',
    userInfo:
      (localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo'))) ||
      {},
    parameter:
      (localStorage.getItem('parameter') &&
        JSON.parse(localStorage.getItem('parameter'))) ||
      {},
    checkoutIds: [],
    defaultHearder: []
  },
  getters: {
    // 城市服务商ID
    companyId: state => state.userInfo.companyId,
    // 进件人员ID
    userId: state => state.userInfo.id,
    parameter: state => state.parameter,
    // 背景色兼容
    bgcolor: state => {
      if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
        return '#eaf0f5'
      } else {
        return '#D6E3E8'
      }
    },

    checkoutIds: state => state.checkoutIds,
    // 公用下拉
    selects: state => state.selects,

  },

  mutations: {

    setParameter: (state, payload) => {
      let parameter =
        (localStorage.getItem('parameter') &&
          JSON.parse(localStorage.getItem('parameter'))) ||
        state.parameter
      if (parameter[payload.path]) {
        parameter[payload.path] = {
          ...parameter[payload.path],
          ...payload
        }
        parameter[payload.path].value = {
          ...parameter[payload.path].value,
          ...payload.value
        }
      } else {
        parameter[payload.path] = payload
      }
      localStorage.setItem('parameter', JSON.stringify(parameter))
      state.parameter = parameter
    },

    setCheckoutIds: (state, ids) => {
      state.checkoutIds = ids;
    },

    setRouterList: (state, routerList) => {
      state.routerList = routerList
    }
  },

  actions: {
    routerList: ({ commit }, payload) => {
      // state.routerList = [...payload]
      localStorage.setItem('routerList', JSON.stringify(payload))
      commit('setRouterList', payload)
    },
    userInfo({ state }, payload) {
      state.userInfo = payload
      localStorage.setItem('userInfo', JSON.stringify(payload))
    },
    parameter({ commit }, payload) {
      return commit('setParameter', payload)
    },
    downloadFile(ctx, payload) {
      return request.get(payload.url, payload.params, { responseType: 'blob' })
    }
  }
})
